import React from "react";
import MDInput from "./MDInput";

const TextInput = props => (
    <MDInput {...props} {...props.field} />
);

export default TextInput;

